var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.75V12.0833",
    stroke: "#808080",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55643 15.7039C3.74383 17.0958 4.89669 18.1862 6.29964 18.2507C7.48014 18.305 8.67934 18.3333 9.99993 18.3333C11.3205 18.3333 12.5197 18.305 13.7002 18.2507C15.1032 18.1862 16.256 17.0958 16.4434 15.7039C16.5657 14.7956 16.6666 13.8647 16.6666 12.9167C16.6666 11.9687 16.5657 11.0378 16.4434 10.1294C16.256 8.7375 15.1032 7.64707 13.7002 7.58257C12.5197 7.52831 11.3205 7.5 9.99993 7.5C8.67934 7.5 7.48014 7.52831 6.29964 7.58257C4.89669 7.64707 3.74383 8.7375 3.55643 10.1294C3.43413 11.0378 3.33325 11.9687 3.33325 12.9167C3.33325 13.8647 3.43413 14.7956 3.55643 15.7039Z",
    stroke: "#808080",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.49999V5.41666C6.25 3.34559 7.92893 1.66666 10 1.66666C12.0711 1.66666 13.75 3.34559 13.75 5.41666V7.49999",
    stroke: "#808080",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadLock);
export default __webpack_public_path__ + "static/media/pad-lock.a6c9be1847fe84496d5a4938f5095f17.svg";
export { ForwardRef as ReactComponent };